import { PROP65_WARNING_LINK } from './constant';
import DOMPurify from 'dompurify';

export const prop65WarningMsg = (prop65: string) => {
  const prop65Link =
    prop65?.includes(PROP65_WARNING_LINK) &&
    `<a href="//${PROP65_WARNING_LINK}" class="text-decoration-underline" target="_blank" rel="noopener noreferrer">${PROP65_WARNING_LINK}</a>`;

  const htmlString = prop65?.replace(PROP65_WARNING_LINK, prop65Link);
  return DOMPurify.sanitize(htmlString ?? "");
};
